import { useModuleState } from "../../../redux/hooks/superAdminCustomHooks/hooks";
import { DashOutlined, PlusCircleFilled } from "@ant-design/icons";
import { Modal, Button, DatePicker } from "antd";
import {
  makeAuditModeFalse,
  makeEditModeTrue,
  makeExtendPerModuleIDFalse,
  makeExtendPerModuleIDTrue,
  makeViewModeTrue,
  openModal,
} from "../../../redux/Admin/adminActions";
import { useDispatch } from "react-redux";
import {
  makeAddModeFalse,
  makeEditModeFalse,
  closeModal,
} from "../../../redux/Admin/adminActions";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SuccessPopup from "./modals/SuccessModal";
import ErrorPopup from "./modals/ErrorModal";
import axios from "axios";
import LoadingSpinner from "./loaders/LoadingSpinner";
import { useGetClient } from "../../../hooks/useGetClient";
import ImportUsersModal from "./modals/ImportUsersModal";

export default function TableActionColumn({
  record,
  handleViewDetails,
  handleEditBtnClick,
  handleExtendSubscriptionClick,
  handleCancelSubscriptionClick,
  handleImpersonateMode,
  isModalOpen,
  clientId,
  refetchClients,
  handleAuditClick,
}) {
  const index = Number(record.key);
  const navigate = useNavigate();
  const {
    isPerModule,
    // isAllModule,
    isExtendModeOpen,
    isCancelModeOpen,
    closeCancelMode,
    toggleModuleMode,
    closeExtendMode,
    // isPerModuleIDModal,
    perModuleID,
  } = useModuleState(index);

  const dispatch = useDispatch();

  const [successMessage, setSuccessMessage] = useState(null);
  const [dateError, setDateError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingModuleId, setLoadingModuleId] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const { data: client, refetch: refetchClient } = useGetClient(clientId);

  useEffect(() => {
    refetchClient();
  }, [client, refetchClient]);

  const handleModalOpen = (e) => {
    e.stopPropagation();
    dispatch(openModal(index));
    dispatch(makeAddModeFalse());
  };

  const handleModalClose = (e) => {
    e.stopPropagation();
    dispatch(closeModal(index));
    dispatch(makeEditModeFalse());
    dispatch(makeAuditModeFalse());
  };

  const handleImportUsersClick = (e) => {
    e.stopPropagation();
    handleModalClose(e);
    setIsImportModalOpen(true);
  };

  const handlePerModuleClick = (index, id) => {
    dispatch(makeExtendPerModuleIDTrue(index, id));
    console.log("hello");
  };

  const handlePerModuleClose = (index) => {
    setSelectedDate(null);
    dispatch(makeExtendPerModuleIDFalse(index));
  };

  const [selectedDate, setSelectedDate] = React.useState(null);
  const onChange = (date, dateString) => {
    console.log(date, dateString);
    setSelectedDate(dateString);
    if (selectedDate) {
      setDateError(null);
    }
  };

  // const handleUpdate = (moduleId, moduleName) => {
  //   if (selectedDate) {
  //     const companyDetails = record;
  //     console.log("Updating:", {
  //       moduleId,
  //       moduleName,
  //       date: selectedDate,
  //       companyDetail: companyDetails,
  //     });

  //     handlePerModuleClose(index);
  //   }
  // };

  const handleExtendAllSubscriptions = async () => {
    handlePerModuleClose(index);
    try {
      setIsLoading(true);
      const token = localStorage.getItem("superAdminToken");

      if (!token) {
        return console.error("Token not found");
      }

      const payload = {
        date: selectedDate,
      };

      if (!selectedDate) {
        setDateError("Please select a date");
        setIsLoading(false);
        return;
      }

      if (selectedDate) {
        const response = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/super-admin/client-management/client/${clientId}/extend-all-modules`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setSuccessMessage(response.data.message);

        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    } catch (error) {
      setIsLoading(false);

      const status = error?.response?.status;
      const apiErrors = error?.response?.data?.errors;
      const fallbackMessage =
        error?.response?.data?.message || "Something went wrong";

      if (status >= 400 && status < 500) {
        // Show detailed error for client-side issues (400 range)
        if (apiErrors && typeof apiErrors === "object") {
          const firstErrorMessage =
            Object.values(apiErrors)[0]?.[0] || fallbackMessage;
          setErrorMessage(firstErrorMessage);
        } else {
          setErrorMessage(fallbackMessage);
        }
      } else {
        // Show generic message for 500+ errors
        setErrorMessage("An error occurred. Please try again later.");
      }

      console.error("Error:", error.response?.data || error.message);
    }
  };

  const handleExtendOneSubscription = async (moduleId) => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("superAdminToken");

      if (!token) {
        return console.error("Token not found");
      }

      const payload = {
        module_id: moduleId,
        date: selectedDate,
      };

      if (!selectedDate) {
        setDateError("Please select a date");
        setIsLoading(false);
        return;
      }

      if (selectedDate) {
        const response = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/super-admin/client-management/client/${clientId}/extend-module`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setSuccessMessage(response.data.message);

        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
        refetchClient();
      }
    } catch (error) {
      setIsLoading(false);

      const status = error?.response?.status;
      const apiErrors = error?.response?.data?.errors;
      const fallbackMessage =
        error?.response?.data?.message || "Something went wrong";

      if (status >= 400 && status < 500) {
        // Show detailed error for client-side issues (400 range)
        if (apiErrors && typeof apiErrors === "object") {
          const firstErrorMessage =
            Object.values(apiErrors)[0]?.[0] || fallbackMessage;
          setErrorMessage(firstErrorMessage);
        } else {
          setErrorMessage(fallbackMessage);
        }
      } else {
        // Show generic message for 500+ errors
        setErrorMessage("An error occurred. Please try again later.");
      }

      console.error("Error:", error.response?.data || error.message);
    }
  };

  const handleCancelAllSubscriptions = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("superAdminToken");

      if (!token) {
        return console.error("Token not found");
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/super-admin/client-management/client/${clientId}/cancel-all-subscriptions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSuccessMessage(response.data.message);

      setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      refetchClient();
    } catch (error) {
      setIsLoading(false);

      const status = error?.response?.status;
      const apiErrors = error?.response?.data?.errors;
      const fallbackMessage =
        error?.response?.data?.message || "Something went wrong";

      if (status >= 400 && status < 500) {
        // Show detailed error for client-side issues (400 range)
        if (apiErrors && typeof apiErrors === "object") {
          const firstErrorMessage =
            Object.values(apiErrors)[0]?.[0] || fallbackMessage;
          setErrorMessage(firstErrorMessage);
        } else {
          setErrorMessage(fallbackMessage);
        }
      } else {
        // Show generic message for 500+ errors
        setErrorMessage("An error occurred. Please try again later.");
      }

      console.error("Error:", error.response?.data || error.message);
    }
  };

  const handleCancelSubscription = async (moduleId) => {
    try {
      setLoadingModuleId(moduleId);
      const token = localStorage.getItem("superAdminToken");

      if (!token) {
        console.error("Token not found");
        return;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/super-admin/client-management/client/${clientId}/cancel-subscription`,
        {
          data: { module_id: moduleId },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSuccessMessage(response.data.message);
      refetchClient();
      refetchClients();
    } catch (error) {
      const status = error?.response?.status;
      const apiErrors = error?.response?.data?.errors;
      const fallbackMessage =
        error?.response?.data?.message || "Something went wrong";

      if (status >= 400 && status < 500) {
        if (apiErrors && typeof apiErrors === "object") {
          const firstErrorMessage =
            Object.values(apiErrors)[0]?.[0] || fallbackMessage;
          setErrorMessage(firstErrorMessage);
        } else {
          setErrorMessage(fallbackMessage);
        }
      } else {
        setErrorMessage("An error occurred. Please try again later.");
      }

      console.error("Error:", error.response?.data || error.message);
    } finally {
      setLoadingModuleId(null);
    }
  };

  const handleViewClick = (e) => {
    e.stopPropagation();
    navigate(`/super_admin/client-details/${clientId}`);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    dispatch(makeEditModeTrue());
    dispatch(makeViewModeTrue());
    navigate(`/super_admin/client-details/${clientId}`);
  };

  return (
    <div className="position-relative action" onClick={handleModalOpen}>
      <DashOutlined style={{ cursor: "pointer", color: "#16166C" }} />
      <div className="extended-modal-wrapper">
        {successMessage && (
          <SuccessPopup
            message={successMessage}
            onClose={() => setSuccessMessage(null)}
          />
        )}
        {errorMessage && (
          <ErrorPopup
            message={errorMessage}
            onClose={() => setErrorMessage(null)}
          />
        )}
        <Modal
          title={
            <div className="d-flex justify-content-between align-items-center">
              <span>Extend Module Subscription</span>
              <Button
                size="middle"
                className="add-client-button"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleModuleMode();
                }}
              >
                {isPerModule ? "Extend all modules" : "Extend per module"}
              </Button>
            </div>
          }
          open={isExtendModeOpen}
          closable={false}
          onCancel={closeExtendMode}
          footer={null}
          wrapClassName="extended-modal"
          width={800}
        >
          <div className="module-cards-container1">
            {isPerModule ? (
              client?.modules?.map((module, index) => (
                <>
                  <div key={module.id} className="module-card1">
                    <div className="module-card-content1">
                      <span className="module-card1-text">{module.name}</span>
                      <PlusCircleFilled
                        style={{
                          color: "#16166C",
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePerModuleClick(index, module.id);
                        }}
                      />
                    </div>
                  </div>
                  <Modal
                    open={perModuleID === module.id}
                    footer={null}
                    closable={false}
                    wrapClassName="extended-modal1"
                    onCancel={() => handlePerModuleClose(index)}
                  >
                    <div className="d-flex flex-column px-4 py-4 gap-3">
                      <div className="d-flex flex-column">
                        <h1 className="font-weight-bold mb-3 header">
                          {module.name}
                        </h1>
                        <h1>Current Subscription Expiry Date</h1>
                        <span>{module?.expiry_date}</span>
                      </div>

                      <div>
                        <h1>Extend till</h1>
                        <DatePicker onChange={onChange} />
                      </div>
                      <Button
                        size="middle"
                        className="add-client-button w-25"
                        onClick={() => handleExtendOneSubscription(module.id)}
                        // disabled={!selectedDate}
                      >
                        {isLoading ? <LoadingSpinner /> : "Update"}
                      </Button>
                    </div>
                  </Modal>
                </>
              ))
            ) : (
              <div className="d-flex flex-column gap-3">
                <div>
                  <h1>Extend all till</h1>

                  <DatePicker onChange={onChange} />
                  {dateError && <p className="date-error">{dateError}</p>}
                </div>

                <Button
                  size="middle"
                  className="add-client-button w-50"
                  onClick={() => handleExtendAllSubscriptions()}
                >
                  {isLoading ? <LoadingSpinner /> : "Update"}
                </Button>
              </div>
            )}
          </div>
        </Modal>

        <Modal
          className="custom-modal"
          width={200}
          open={isModalOpen[index]}
          closable={false}
          onCancel={handleModalClose}
          footer={null}
        >
          <div className="d-flex flex-column gap-3">
            <button className="modal_button" onClick={handleViewClick}>
              View
            </button>
            <button className="modal_button" onClick={handleEditClick}>
              Edit
            </button>
            <button
              className="modal_button"
              onClick={() => handleAuditClick(index)}
            >
              Audit details
            </button>
            <button
              className="modal_button"
              onClick={() => handleExtendSubscriptionClick(index)}
            >
              Extend Subscription
            </button>
            <button
              className="modal_button"
              onClick={() => handleCancelSubscriptionClick(index)}
            >
              Cancel Subscription
            </button>
            <button
              className="modal_button"
              onClick={handleImportUsersClick}
            >
              Import users
            </button>
            <button className="modal_button" onClick={handleImpersonateMode}>
              Login as administrator
            </button>
          </div>
        </Modal>
        {/* cancel module */}
        <Modal
          title={
            <div className="d-flex justify-content-between align-items-center">
              <span>Cancel Module Subscription</span>
            </div>
          }
          open={isCancelModeOpen}
          closable={false}
          onCancel={closeCancelMode}
          footer={null}
          wrapClassName="extended-modal"
          width={800}
        >
          <div className="module-cards-container1">
            {client?.modules?.length === 0 && <p>No Modules</p>}
            {client?.modules?.map((module, index) => (
              <>
                <div key={module.id} className="module-card1">
                  <div className="module-card-content1">
                    <span className="module-card1-text">{module.name}</span>
                  </div>
                  <Button
                    size="middle"
                    className="add-client-button w-50"
                    style={{ marginTop: "20px" }}
                    onClick={() => handleCancelSubscription(module.id)}
                  >
                    {loadingModuleId === module.id ? (
                      <LoadingSpinner />
                    ) : (
                      "Cancel"
                    )}
                  </Button>
                </div>
              </>
            ))}
          </div>
          <Button
            size="middle"
            className="add-client-button w-full"
            style={{ position: "fixed", bottom: "8rem" }}
            onClick={() => handleCancelAllSubscriptions()}
          >
            {isLoading ? <LoadingSpinner /> : "Cancel all Modules"}
          </Button>
        </Modal>

        {/* Import Users Modal */}
        <ImportUsersModal
          isOpen={isImportModalOpen}
          onClose={() => setIsImportModalOpen(false)}
          client={client || record}
          clientId={clientId}
          onSuccess={(msg) => {
            setSuccessMessage(msg);
            if (refetchClients) refetchClients();
            if (refetchClient) refetchClient();
          }}
        />
      </div>
    </div>
  );
}
